import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    return {x: 0, y: 0}
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: {name: 'Home', params: {lang: 'en'}}
    },
    {
      path: '/:lang(en|fr|zh)',
      component: resolve => require(['../Layout'], resolve),
      children: [
        {
          name: 'Home',
          path: '',
          component: resolve => require(['../components/Home'], resolve)
        },
        {
          name: 'Services',
          path: 'services',
          redirect: {name: 'Services.List'},
          component: resolve => require(['../components/Services'], resolve),
          scrollBehavior (to, from, savedPosition) {
            if (savedPosition) {
              return savedPosition
            }

            return {x: 0, y: 0}
          },

          children: [
            {
              name: 'Services.List',
              path: '',
              component: resolve => require(['../components/Services/List'], resolve)
            },
            {
              name: 'Services.Advice',
              path: 'advice',
              component: resolve => require(['../components/Services/Advice'], resolve),
              meta: {service: 'advice'}
            },
            {
              name: 'Services.Business',
              path: 'business',
              component: resolve => require(['../components/Services/Business'], resolve),
              meta: {service: 'business'}
            },
            {
              name: 'Services.Event',
              path: 'event',
              component: resolve => require(['../components/Services/Event'], resolve),
              meta: {service: 'event'}
            },
            {
              name: 'Services.Investment',
              path: 'investment',
              component: resolve => require(['../components/Services/Investment'], resolve),
              meta: {service: 'investment'}
            },
            {
              name: 'Services.Recruitment',
              path: 'recruitment',
              component: resolve => require(['../components/Services/Recruitment'], resolve),
              meta: {service: 'recruitment'}
            }
          ]
        },
        {
          name: 'Team',
          path: 'team',
          component: resolve => require(['../components/Team'], resolve)
        },
        {
          name: 'Contact',
          path: 'contact',
          component: resolve => require(['../components/Contact'], resolve)
        },
        {
          name: 'Cookies',
          path: 'cookies',
          component: resolve => require(['../components/Cookies'], resolve)
        },
        {
          name: 'Legal',
          path: 'legal',
          component: resolve => require(['../components/Legal'], resolve)
        }
      ]
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js